import { render, staticRenderFns } from "./FormTypes.vue?vue&type=template&id=baa3fdba&scoped=true"
import script from "./FormTypes.vue?vue&type=script&lang=js"
export * from "./FormTypes.vue?vue&type=script&lang=js"
import style0 from "./FormTypes.vue?vue&type=style&index=0&id=baa3fdba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa3fdba",
  null
  
)

export default component.exports